module.exports = __webpack_public_path__ + "99d64f853be6eea14b10afb01c96fa72.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-naiyou.png
// module id = 232
// module chunks = 30